export default __webpack_public_path__ + "static/media/brand-icons.cac87dc0.woff";